import React from 'react'

class DropdownToggle extends React.Component {
    constructor(props, context) {
        super(props, context)

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(e) {
        e.preventDefault()

        this.props.onClick(e)
    }

    render() {
        return (
            <button type="button" className="btn btn-default dropdown-toggle" onClick={this.handleClick}>
                {this.props.children}
            </button>
        )
    }
}

export default DropdownToggle


// WEBPACK FOOTER //
// ./src/components/dropdown_toggle.jsx